<template>
	<div>
		<el-card shadow="never">
			<div class="header-row" slot="header">
				<div class="title">快捷入口</div>
				<!-- <el-button type="text" size="mini" icon="el-icon-edit">编辑</el-button> -->
				<div style="color: #409eff; font-size: 14px; cursor: pointer" @click="editEntries">
					<i class="el-icon-edit"></i>
					<span>编辑</span>
				</div>
			</div>
			<div class="entry-grid">
				<template v-for="item in entries">
					<div
						v-if="item.checked"
						:key="item.name"
						class="entry-item"
						:style="{
							'--color': item.color,
						}"
						@click="goPage(item.url)">
						<div class="menu">
							<!-- <div class="entry-icon">{{ item.icon }}</div> -->
							<img :src="`/img/menus/${item.icon}.png`" alt="图标" class="entry-icon" />
							<div class="entry-name">{{ item.name }}</div>
						</div>
					</div>
				</template>
			</div>
		</el-card>
		<MenuDialog :dialogVisible.sync="dialogVisible" :menuList="entries" @updateSuccess="updateSuccess" />
	</div>
</template>

<script>
	import MenuDialog from './menuDialog.vue';
	export default {
		name: 'QuickEntry',
		components: {
			MenuDialog,
		},

		data() {
			return {
				entries: [
					{
						name: '资产台账',
						icon: 'assetLedger',
						color: '#286BFF',
						checked: true,
						url: '/pages/asset/assetLedger',
					},
					{
						name: '租赁合同',
						icon: 'occupancyMap',
						color: '#FB923C',
						checked: true,
						url: '/pages/assets/occupancyMap',
					},
					{
						name: '收款计划',
						icon: 'collectionPlan',
						color: '#8172FF',
						checked: true,
						url: '/pages/assets/collectionPlan',
					},
					{
						name: '资产地图',
						icon: 'assetMap',
						color: '#16A34A',
						checked: true,
						url: '/pages/asset/assetMap',
					},
					{
						name: '客户分析',
						icon: 'customerAnalysis',
						color: '#EF4444',
						checked: true,
						// url: '/pages/customer/customerAnalysis',
					},
					{
						name: '财务分析',
						icon: 'financialAnalysis',
						color: '#4BC7F7',
						checked: true,
						// url: '/pages/finance/financialAnalysis',
					},
					{
						name: '资产盘点',
						icon: 'assetInventory',
						color: '#FB71A7',
						checked: true,
						url: '/pages/asset/assetInventory',
					},
					{
						name: '工单管理',
						icon: 'workOrderManagement',
						color: '#4080FF',
						checked: true,
						// url: '/pages/workOrder/workOrderManagement',
					},
					// {
					// 	name: '物业管理',
					// 	icon: 'workOrderManagement',
					// 	color: '#FB923C',
					// 	checked: true,
					// 	// url: '/pages/workOrder/workOrderManagement',
					// },
					// {
					// 	name: '系统设置',
					// 	icon: 'workOrderManagement',
					// 	color: '#8172FF',
					// 	checked: true,
					// 	url: '/pages/common/storeInfoManage',
					// },
				],
				dialogVisible: false,
			};
		},
		mounted() {
			this.entries = localStorage.getItem('quickEntries')
				? JSON.parse(localStorage.getItem('quickEntries'))
				: this.entries;
		},
		methods: {
			updateSuccess(newList) {
				this.entries = newList;
				localStorage.setItem('quickEntries', JSON.stringify(newList));
				this.dialogVisible = false;
			},
			editEntries() {
				this.dialogVisible = true;
			},
			goPage(url) {
				if (!url) return;
				this.$router.push(url);
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.el-card__body) {
		// height: 387px;
	}
	.header-row {
		display: flex;
		justify-content: space-between;
		height: 20px;
	}
	.title {
		font-weight: bold;
	}
	.entry-grid {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		gap: 19px;
	}
	.entry-item {
		width: calc(100% / 4 - 19px);
		text-align: center;
		border-radius: 4px;
		display: flex;
		justify-content: center;
	}
	.menu {
		box-sizing: border-box;
		width: 120px;
		padding: 12px;
		border-radius: 10px;
		cursor: pointer;
		transition: all 0.3s ease;
	}
	.menu:hover {
		background-color: color-mix(in srgb, var(--color) 10%, white);
		border-color: var(--color);
		transform: translateY(-4px);
	}
	.entry-icon {
		width: 56px;
		height: 56px;
		font-size: 24px;
		margin-bottom: 8px;
	}
	.entry-name {
		font-size: 16px;
		color: #0f172a;
	}
</style>
